import React from 'react';
import { createRoot } from 'react-dom/client';
import SwibeWebsite from './SwibeWebsite.jsx';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<SwibeWebsite />);
